import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgMediaLiveVideoOff24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  "aria-label": "Live Video Off",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20.455 1.403a.75.75 0 0 1 .142 1.052l-16 21a.75.75 0 1 1-1.194-.91l16-21a.75.75 0 0 1 1.052-.142",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M19.882 3.214A2 2 0 0 0 18.975 3H5.025A2.025 2.025 0 0 0 3 5.025v10.8c0 1.118.907 2.025 2.025 2.025h3.706L9.76 16.5H5.025a.675.675 0 0 1-.675-.675v-10.8c0-.373.302-.675.675-.675h13.95l.04.001zM11.645 16.5h7.33a.675.675 0 0 0 .675-.675V5.994l1.24-1.628q.108.311.11.659v10.8a2.025 2.025 0 0 1-2.025 2.025h-8.358zM7.36 19.65H3.675a.675.675 0 1 0 0 1.35h2.656zM8.217 21l1.028-1.35h11.08a.675.675 0 1 1 0 1.35zm6.636-11.185-4.078-2.957a.787.787 0 0 0-1.25.638v6.083a.788.788 0 0 0 1.25.638l1.618-1.173zm-3.978 2.662 2.675-1.94-2.675-1.939z",
  clipRule: "evenodd"
}));

export { SvgMediaLiveVideoOff24 as default };
//# sourceMappingURL=MediaLiveVideoOff24.js.map
